export default __webpack_public_path__ + "static/media/gloverads.4c9b12b3.svg";